module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "P_WFP_ChapHead",
    attrs: {
      "id": "auto_bookmark_toc_1"
    }
  }, [_c('span', [_vm._v("Book Description")])]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_BodyText"
  }, [_vm._v("Captain Willard Phule has whipped his troops into shape. That’s how he turned Phule’s Company from the laughingstock of the Legion into … a crack team of casino security guards.")]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_BodyText"
  }, [_vm._v("Now his company is deployed to help an underdeveloped planet. And what better way to utilize their major area of expertise—goofing off—than to turn it into the biggest intergalactic playground ever?")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-34aefee5","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/section0002.vue
// module id = 63
// module chunks = 0